(() => {
  const initialise = (scope) => {
    scope.querySelectorAll('[data-fabrics-index]').forEach((root) => {
      if (root.dataset.initialised) return;
      root.dataset.initialised = 'true';
      const grid = root.querySelector('[data-fabric-grid]');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-fabric-card]')];
      const search = root.querySelector('[data-fabric-search]');
      const maker = root.querySelector('[data-fabric-maker]');
      const group = root.querySelector('[data-fabric-group]');
      const results = root.querySelector('[data-fabric-results]');
      const normalise = (text) => text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
      const manufacturer = (card) => card.dataset.maker.startsWith('Kvadrat') ? 'Kvadrat' : card.dataset.maker.trim();
      cards.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name, undefined, { numeric: true, sensitivity: 'base' }));
      cards.forEach((card) => grid.append(card));
      [...new Set(cards.map(manufacturer).filter(Boolean))].sort().forEach((name) => {
        maker.add(new Option(name, name));
      });
      const context = new URLSearchParams(location.search);
      search.value = context.get('fabric_search') || '';
      if (group && [...group.options].some(option => option.value === context.get('fabric_group'))) group.value = context.get('fabric_group');
      if ([...maker.options].some(option => option.value === context.get('fabric_maker'))) maker.value = context.get('fabric_maker');
      const filter = () => {
        const terms = normalise(search.value).split(/\s+/).filter(Boolean);
        let count = 0;
        for (const card of cards) {
          const haystack = normalise(card.dataset.search);
          const visible = terms.every((term) => haystack.includes(term)) && (!maker.value || maker.value === manufacturer(card)) && (!group?.value || group.value === card.dataset.group);
          card.hidden = !visible;
          if (visible) count++;
        }
        results.textContent = (count === 1 ? results.dataset.one : results.dataset.many).replace('[count]', count);
        root.querySelector('[data-fabric-empty]').hidden = count !== 0;
        window.KinFabricJourney?.setBrowse({fabric_search:search.value,fabric_maker:maker.value,...(group ? {fabric_group:group.value} : {})});
      };
      const reset = () => {
        search.value = '';
        maker.value = '';
        if (group) group.value = '';
        filter();
        search.focus();
      };
      search.addEventListener('input', filter);
      maker.addEventListener('change', filter);
      group?.addEventListener('change', filter);
      root.querySelectorAll('[data-fabric-clear], [data-fabric-reset]').forEach((button) => button.addEventListener('click', reset));
      root.querySelector('[data-fabric-filters]').hidden = false;
      filter();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

